import React from 'react';
import { Box, CircularProgress, Alert, Paper } from '@mui/material';

const LoadingErrorWrapper = ({ loading, error, children }) => {
  if (loading) {
    return (
      <Paper className="w-full p-8">
        <Box className="flex items-center justify-center h-64">
          <CircularProgress />
        </Box>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper className="w-full p-8">
        <Box className="flex items-center justify-center h-64">
          <Alert severity="error" className="w-full">
            {error instanceof Error ? error.message : 'An error occurred while loading the data'}
          </Alert>
        </Box>
      </Paper>
    );
  }

  return children;
};

export default LoadingErrorWrapper;